import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "label",
    sortable: true,
    searchable: true,
    type: "text",
  },
];

export default function List() {
  return <ResourceListPage url="roles" columns={columns} />;
}
